// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"601":"6cc24957","875":"b37fad64","887":"f64edcb8"}[chunkId] + ".chunk.js";
};